import { useMemo } from 'react';
import { useSnackbar } from 'notistack';
import { getResponseMessage } from 'utils/helpers';

// Allow to use snackbars in simplier way:
//    const message = useMessage();
// Then simpy run needed variant method:
//    message.success('Text');
// Or run it with default variant:
//    message('Text)
// You can setup default variant while creating an instance:
//    const message = useMessage('success');
// In this case 'success' variant will be available as a default:
//    message('Success message');
// You can also setup variant directly as a second argument:
//    message('Text', 'error');

const useMessage = (defaultVariant = 'success') => {
  const { enqueueSnackbar } = useSnackbar();

  return useMemo(() => {
    const messanger = function (text, variant = defaultVariant, config = {}) {
      enqueueSnackbar(text, {
        variant,
        autoHideDuration: 5000,
        ...config,
      });
    };
    messanger.default = (text, ...rest) => messanger(text, 'default', ...rest);
    messanger.success = (text, ...rest) => messanger(text, 'success', ...rest);
    messanger.error = (text, ...rest) => messanger(text, 'error', ...rest);
    messanger.info = (text, ...rest) => messanger(text, 'info', ...rest);
    messanger.warning = (text, ...rest) => messanger(text, 'warning', ...rest);
    messanger.warn = messanger.warning;
    messanger.responseError = (ex, t, ...rest) => {
      let text = t;

      if (!text) {
        if (ex.status === 'FETCH_ERROR') {
          text = 'Internet connection problems';
        } else if (ex.status === 500) {
          text = 'Server error';
        } else {
          text = 'Something went wrong...';
        }
      }
      console.error(ex);
      messanger.error(getResponseMessage(ex) || text, ...rest);
    };
    return messanger;
  }, [enqueueSnackbar, defaultVariant]);
};

export default useMessage;
